import router from '@/router'

export default () => {
  router.addRoute({
    path: '/truelayer/callback',
    name: 'truelayer-callback',
    component: () => import('./truelayerCallback.vue')
  })
}
